export const readJwtExpiry = (token: string | null | undefined): number | null => {
  const payload = token?.split('.')[1];
  if (!payload) return null;

  try {
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const exp = (JSON.parse(atob(padded)) as { exp?: unknown }).exp;

    return typeof exp === 'number' ? exp * 1000 : null;
  } catch {
    return null;
  }
};
